
export enum CustomerTypeCd {
	BILL_TO = 'BillTo',
	CORPORATE = 'Corporate',
	FUTURE = 'Future',
	PICKUP_DELIVERY = 'PickupDelivery',
	SERVICE_RECIPIENT = 'ServiceRecipient'}

